import { PropsWithChildren } from "react";
import { useDialogCtx } from "../useDialogCtx";
import { DialogWrap } from "./DialogWrap";
import { DrawerWrap } from "./DrawerWrap";
type Props = PropsWithChildren;
export function BaseContent({
  children
}: Props) {
  const ctx = useDialogCtx();
  return ctx.isLargeScreen ? <DialogWrap {...ctx} data-sentry-element="DialogWrap" data-sentry-component="BaseContent" data-sentry-source-file="BaseContent.tsx">{children}</DialogWrap> : <DrawerWrap {...ctx} data-sentry-element="DrawerWrap" data-sentry-component="BaseContent" data-sentry-source-file="BaseContent.tsx">{children}</DrawerWrap>;
}